import Company from "./company";

export default Company;
